import version from './version.json';

const env = { ...window.env };

const config = {
    // BUILD INFO
    BUILD: {
        SOURCE: version.sourceBranch,
        VERSION: version.semanticVersion,
        BUILD_DATE: version.buildDate,
        COMMIT_HASH: version.commitHash,
    },

    // CRA
    NODE_ENV: process.env.NODE_ENV || 'unknown',
    PUBLIC_URL: process.env.PUBLIC_URL || '/',

    // APP SPECIFIC
    ENVIRONMENT: env.ENVIRONMENT || 'local',
    API_BASE_URL: env.API_BASE_URL || 'unknown', // ItsmeOnboardingAPI URL
    BASE_NAME: env.BASE_NAME || 'unknown',
    SP: env.SP || 'unknown',
    PI2_JWT_V1: env.PI2_JWT_V1 || 'unknown',  // query parameter useful for getting token DO NOT REMOVE
    ITSME_URL: env.ITSME_URL || 'unknown',
    TOKEN: env.TOKEN || 'unknown',  // name of item in local storage
    PI2_AUTH_TYPE: env.PI2_AUTH_TYPE || 'unknown',
    PI2_SP: env.PI2_SP || 'unknown',
    PI2_ACS: env.PI2_ACS || 'unknown',
    BASE_URL: env.BASE_URL || 'unknown',
    PI2_URL: env.PI2_URL || 'unknown',
    PI2_URL_WITH_ITSME: env.PI2_URL_WITH_ITSME || 'unknown',
};

export type Config = typeof config;
export default config;